"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prettier/prettier */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const dynamic_1 = __importDefault(require("next/dynamic"));
const next12_components_custom_link_1 = __importDefault(require("@gcloud-npm/next12.components.custom-link"));
const next12_components_text_info_n_1 = __importDefault(require("@gcloud-npm/next12.components.text-info-n"));
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
const next12_app_controller_reducers_sagas_modals_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer");
const next12_app_controller_reducers_sagas_main_reducer_r_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer-r");
class CPMenu extends react_1.Component {
    constructor(props) {
        super(props);
        this.handleCpModal = () => {
            const device = (0, next12_utils_common_1.getDeviceKindDependsOnViewPort)();
            const { addModal, cp, municipios, municipio, setCpModalClosed } = this.props;
            const CPModal = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require("../../../modals/cp"))));
            let modalProps = {
                contentPosition: "center--bottom",
                opacityLayoutColor: "blur",
                inSceneEffect: "fadeInBottom",
                contentInsideContainer: false,
                outSceneEffect: "fadeOutBottom",
                closeByClickingOutside: true,
                onCloseHandler: () => {
                    setCpModalClosed(true);
                },
            };
            if (device !== "mobile") {
                modalProps = {
                    contentPosition: "right--top",
                    opacityLayoutColor: "blur",
                    inSceneEffect: "fadeInBottom",
                    contentInsideContainer: true,
                    outSceneEffect: "fadeOutBottom",
                    closeByClickingOutside: true,
                };
            }
            setCpModalClosed(false);
            addModal({
                id: "cp",
                Element2Show: CPModal,
                modalProps,
                elementProps: {
                    cp,
                    municipio,
                    municipios,
                },
            });
        };
        this.state = {
            device: null,
        };
    }
    render() {
        const { cp } = this.props;
        return (react_1.default.createElement(next12_components_custom_link_1.default, { title: "C\u00F3digo postal", ariaLabel: "C\u00F3digo postal", onClick: this.handleCpModal, taggingInfo: {
                componentName: "header",
                componentContent: "openCP",
                componentVariation: "all",
                componentPerso: "",
                componentProduct: "",
            } },
            react_1.default.createElement("div", { key: `Item-${"Ofertas"}`, className: `menu-item ${"Ubicacion"}`, "data-cy": "Header ubicacion" },
                react_1.default.createElement("svg", { version: "1.1", id: "gps", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 200 200", width: 15 },
                    react_1.default.createElement("path", { d: "M149.7,21.1C136.4,7.8,118.8,0.5,100,0.5S63.6,7.8,50.3,21.1C37.1,34.3,29.8,52,29.8,70.7c0,15.5,9.2,40.7,27.3,75\r\n\tc13.2,25.1,26.7,46.2,26.8,46.4l0.4,0.6l0.5,0.5c4.1,4.1,9.5,6.3,15.2,6.3h0c5.8,0,11.2-2.2,15.2-6.3l0.5-0.5l0.3-0.5\r\n\tc0.1-0.2,13.6-21.3,26.9-46.4c18.2-34.3,27.4-59.5,27.4-75C170.2,52,162.9,34.3,149.7,21.1z M100,44.5c14.2,0,25.7,11.5,25.7,25.7\r\n\tc0,14.2-11.5,25.7-25.7,25.7S74.3,84.3,74.3,70.2C74.3,56,85.8,44.5,100,44.5z" })),
                react_1.default.createElement("div", { className: "text-gap" },
                    react_1.default.createElement(next12_components_text_info_n_1.default, { text: `Ofertas para ${!cp ? "..." : cp}`, align: "center", fontType: "font-regular", size: "caption02", color: "blue", display: "block", border: "none", className: "custom-text-cp" })))));
    }
}
const mapStateToProps = (state) => ({
    cp: state.main.cp,
});
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next12_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
    setCpModalClosed: (flag) => dispatch(next12_app_controller_reducers_sagas_main_reducer_r_1.actions.setCpModalClosed(flag)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(CPMenu);
//# sourceMappingURL=index.js.map